import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Dashboard from '../Dashboard';
import AuthPage from '../auth/AuthPage';
import { isAuthenticated, getIsValidatingUser } from '../../store/auth/reducer';

const App = (props) => {
	const { 
		isAuthenticated,
		isValidatingUser,
	} = props;

	if (!isAuthenticated && !isValidatingUser) {
		return <AuthPage />
	}

	return <Dashboard />
};

const mapStateToProps = (state) => {
	return {
		isAuthenticated: isAuthenticated(state.auth),
		isValidatingUser: getIsValidatingUser(state.auth),
	}
}

export default withRouter(connect(mapStateToProps)(App));


// WEBPACK FOOTER //
// ./src/components/App/index.js